// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"106":"8498ade1","608":"13fbf47f","700":"8dc6dd01","879":"3d51fbba"}[chunkId] + ".js";
};